export default __webpack_public_path__ + "static/media/green-jump-rope.3fd10348.jpg";